export const inventoryTaskTooltip =
  "Inventory tasks lists all incomplete required attributes of an inventory at different warehouse stages. Each tasks links to inventory edit page where you can update the missing attribute.";
